import * as React from 'react';
import { Breadcrumb } from './breadcrumb';
import { Button } from './button';
import { cn } from '../../lib';

interface PageHeaderProps {
  title: string;
  description?: string;
  eyebrow?: string;
  action?: React.ReactNode;
  breadcrumb?: React.ReactNode;
  className?: string;
}

const PageHeader = ({
  title,
  description,
  eyebrow,
  action,
  breadcrumb,
  className,
}: PageHeaderProps) => {
  return (
    <div className={cn('space-y-4', className)}>
      {breadcrumb && <div className="mb-4">{breadcrumb}</div>}
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div className="border-l-2 border-brand-gold pl-4">
          {eyebrow && (
            <p className="mb-1 text-[0.7rem] font-semibold uppercase tracking-[0.22em] text-brand-gold-dark">
              {eyebrow}
            </p>
          )}
          <h1 className="text-3xl font-bold tracking-tight text-foreground">{title}</h1>
          {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
        </div>
        {action && <div className="flex-shrink-0">{action}</div>}
      </div>
    </div>
  );
};

export { PageHeader };